import { api } from '@/shared/api';
import { sentryModel } from '@/shared/model';

export const fetchFreedomFriendsSelfInfo = async () => {
  try {
    const response = await api.client.get('freedom-prime/self_info');
    return response.data;
  } catch (error) {
    sentryModel.captureException(
      sentryModel.getReadableError(
        'ERR_FAILED_TO_FETCH_FREEDOM_FRIENDS_SELF_INFO',
        error,
      ),
    );
    throw error;
  }
};
